import { View } from "react-native";
import { useTheme } from "~/providers/ThemeProvider";

export const ListSeparator = () => {
    const { colours } = useTheme();

    return <View style={{ height: 2, backgroundColor: colours.border.primary, width: "100%" }} />;
};
